import { useRouter } from "next/router";
import { toIDRFormat } from "../utils/toIDRFormat";
import { toast } from "react-hot-toast";
import fetch from "./fetch";

export default function useStatusHistory(props) {
  const { push } = useRouter();

  const handleSubmit = async (auth, class_id) => {
    try {
      const { status, error, data } = await fetch(
        process.env.NEXT_PUBLIC_API + `/api/v1/transactions`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + auth,
          },
          body: JSON.stringify({
            class_registration_id: [class_id],
          }),
        }
      );

      if (status !== "success") {
        throw new Error(error);
      }
      push(`/checkout/${data}`);
    } catch (error) {
      console.log(error.message);
      toast.error(error.message);
    }
  };

  const statusShort = (status) => {
    switch (status) {
      case 0:
        return "Belum membayar biaya tes masuk";
      case 1:
        return "Silahkan mengerjakan tes masuk. Buka detail untuk informasi tes masuk";
      case 2:
        return "Selamat! Anda lulus tes masuk, silahkan membayar biaya kelas";
      case 3:
        return "Mohon maaf, Anda belum lulus tes masuk";
      case 4:
        return "Selamat! Anda bisa mengikuti kelas sesuai jadwal";
      default:
        break;
    }
  };

  const statusRender = (status) => {
    switch (status) {
      case 0:
        return (
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Belum membayar tes masuk
              </p>
            </div>
            <p className="pl-7 font-nunito text-base font-semibold">
              Biaya tes masuk : {toIDRFormat(props.test_fee)},-
            </p>
          </div>
        );
      case 1:
        return (
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Sudah membayar tes masuk
              </p>
            </div>
            <div className="pl-7">
              <p className="font-nunito text-base font-semibold">
                Tes akan dilaksanakan pada : {props.test_date.split("T")[0]}
              </p>
              <p className="font-nunito text-base font-semibold">
                Pukul : {props.test_date.split("T")[1].split("+")[0]} WIB
              </p>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Sudah membayar tes masuk
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Selamat! Anda lulus tes masuk
              </p>
            </div>
            <p className="pl-7 font-nunito text-base font-semibold">
              Score : {props.test_score}
            </p>
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Belum membayar kelas
              </p>
            </div>
            <p className="pl-7 font-nunito text-base font-semibold">
              Biaya kelas : {toIDRFormat(props.class_fee)},-
            </p>
            <button
              className="rounded-lg bg-[#142D59] py-2 font-nunito text-base font-semibold text-white"
              onClick={() => handleSubmit(props.auth, props.class_id)}
            >
              Bayar
            </button>
          </div>
        );
      case 3:
        return (
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Sudah membayar tes masuk
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-red-600"></div>
              <p className="font-nunito text-base font-semibold text-red-600">
                Mohon maaf, anda tidak lulus tes masuk
              </p>
            </div>
            <p className="pl-7 font-nunito text-base font-semibold text-red-600">
              Score : {props.test_score}
            </p>
          </div>
        );
      case 4:
        return (
          <div className="flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Sudah membayar tes masuk
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Selamat! Anda lulus tes masuk
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <div className="h-5 w-5 rounded-full bg-blue-700"></div>
              <p className="font-nunito text-base font-semibold">
                Sudah membayar kelas
              </p>
            </div>
            <a href={process.env.NEXT_PUBLIC_LMS_URL} target="_blank">
              <button className="rounded-md bg-blue-700 px-3 py-2 text-center font-nunito text-base font-semibold text-white opacity-80 hover:opacity-100">
                Masuk kelas
              </button>
            </a>
          </div>
        );
      default:
        break;
    }
  };

  return {
    push,
    statusShort,
    statusRender,
    handleSubmit,
  };
}
